import { render, staticRenderFns } from "./SupplierViewContacts.vue?vue&type=template&id=68bc75ed"
import script from "./SupplierViewContacts.vue?vue&type=script&lang=js"
export * from "./SupplierViewContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports